import VideosLoader from "../../Loader/student/VideosLoader";
import { useGetVideosQuery } from "../../redux/features/video/videoApi";
import Error from "../ui/Error";
import NotFound from "../ui/NotFound";
import SingleVideo from "./SingleVideo";


export default function VideoList() {
  const { data: videos, isLoading, isError } = useGetVideosQuery();

  //  decide what to render
  let content = null;
  if (isLoading) {
    content = <VideosLoader />
  }
  else if (!isLoading && isError) { content = <Error isPadding={true} /> }
  else if (!isLoading && !isError && !videos?.length) {
    content = <NotFound message={"No video Found"} isPadding={true} />
  }
  else if (!isLoading && !isError && videos?.length) {
    content = videos.map(video => <SingleVideo key={video.id} video={video} />)
  }

  return (
    <div
      className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
      {content}
    </div>
  )
};